import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "order-status" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "dining-status" }
const _hoisted_6 = { class: "flex justify-between text-sm text-gray-500 mt-4" }
const _hoisted_7 = {
  key: 0,
  class: "flex justify-between text-sm text-gray-500 mt-2"
}
const _hoisted_8 = { class: "restaurant" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = { class: "restaurant-info" }
const _hoisted_11 = { class: "restaurant-name" }
const _hoisted_12 = { class: "flex items-center text-xs text-gray-500" }
const _hoisted_13 = { class: "order-content" }
const _hoisted_14 = { class: "order-list" }
const _hoisted_15 = { class: "flex justify-between" }
const _hoisted_16 = { class: "text-left" }
const _hoisted_17 = { class: "order-item-name" }
const _hoisted_18 = { class: "order-item-spec" }
const _hoisted_19 = { class: "text-right" }
const _hoisted_20 = { class: "order-item-price" }
const _hoisted_21 = { class: "order-item-qty" }
const _hoisted_22 = {
  key: 0,
  class: "order-add-list"
}
const _hoisted_23 = { class: "order-add-food" }
const _hoisted_24 = { class: "flex justify-between" }
const _hoisted_25 = { class: "text-left" }
const _hoisted_26 = { class: "order-item-name" }
const _hoisted_27 = { class: "order-item-spec" }
const _hoisted_28 = { class: "text-right" }
const _hoisted_29 = { class: "order-item-price" }
const _hoisted_30 = { class: "order-item-qty" }
const _hoisted_31 = {
  key: 0,
  class: "order-fee"
}
const _hoisted_32 = {
  key: 0,
  class: "flex justify-between mb-1"
}
const _hoisted_33 = {
  key: 1,
  class: "flex justify-between"
}
const _hoisted_34 = { class: "order-fee" }
const _hoisted_35 = { class: "flex justify-between mb-2" }
const _hoisted_36 = { class: "flex justify-between mb-2" }
const _hoisted_37 = {
  key: 0,
  class: "flex justify-between text-red-500"
}
const _hoisted_38 = { class: "actual-amount" }
const _hoisted_39 = { class: "text-red-500" }
const _hoisted_40 = {
  class: "flex justify-between",
  style: {"margin-top":"5px"}
}
const _hoisted_41 = { class: "order-remark" }
const _hoisted_42 = { class: "desc" }
const _hoisted_43 = {
  key: 1,
  class: "order-invoice"
}
const _hoisted_44 = {
  key: 2,
  class: "bottom"
}
const _hoisted_45 = { class: "order-amount" }
const _hoisted_46 = { class: "order-amount-info" }
const _hoisted_47 = { class: "total-amount-text" }
const _hoisted_48 = { class: "order-actual-amount" }
const _hoisted_49 = { style: {"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"} }
const _hoisted_50 = { class: "dialog-content" }
const _hoisted_51 = { class: "order-info" }
const _hoisted_52 = { class: "info-row" }
const _hoisted_53 = { class: "info-row" }
const _hoisted_54 = { class: "info-row" }
const _hoisted_55 = { class: "dialog-buttons" }

import { onMounted, ref, computed, reactive } from 'vue';
  import h5Config from '@/config/config';
  import router from '@/router';
  import { useRoute } from 'vue-router';
  import { getOrder } from '@/service/order';
  import { OrderDetailModel } from '@/model/order';
  import { startPayment } from '@/service/payment';
  import { fetchShopList } from '@/service/base';
  import { showDialog } from 'vant';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'OrderDetailView',
  setup(__props) {

_useCssVars(_ctx => ({
  "25dcf0e9": (_unref(h5Config).themeColor)
}))

  const route = useRoute();
  const orderId = ref(0);
  const orderModel = ref<OrderDetailModel>({});

  const paymentLine = ref<number>(0);
  const paymentTime = ref('');
  const errorMessage = ref('');
  const paymentPollingInterval = ref(null);
  const paymentTimeout = ref(null);
  const paymentWindow = ref(null);
  const displayIosPaymentDialog = ref(false);
  const state = reactive({
    payUrl: '' as string | undefined,
  });
  const displayAADialog = ref(false);
  const diners = ref<number>(1);
  const aaAmount = ref('');

  onMounted(async () => {
    orderId.value = Number(route.params.id || 0);
    await loadOrder();
    loadShop();
  });

  const loadOrder = async () => {
    const res = await getOrder({ orderId: orderId.value });
    orderModel.value = res.result || {};
  };

  const loadShop = async () => {
    const response = await fetchShopList({
      pageNum: 1,
      pageSize: 100,
      data: { shopStatus: 0 },
    });
    if (response.code === 200) {
      const shop = response.result.list.find((item) => item.shopId === orderModel.value.shopId);
      if (shop) {
        paymentLine.value = shop.paymentLine;
      } else {
        showDialog({ message: '店铺不存在' });
      }
    }

    console.log('paymentLine', paymentLine.value);
  };

  // 设备检测
  const isIOS = computed(() => {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  });

  const isWeChatBrowser = computed(() => {
    return /MicroMessenger/i.test(navigator.userAgent);
  });

  const handleStartPayment = async () => {
    try {
      const response = await startPayment({
        orderId: orderModel.value.orderId,
        paymentMethod: 2,
        amount: orderModel.value.remainAmount,
        openId: 'openId',
        returnUrl:
          window.location.origin +
          '/payment/alipay/result?orderId=' +
          orderModel.value.orderId +
          '&orderNo=' +
          orderModel.value.orderNo +
          '&paymentMethod=2',
      });
      if (response.code === 200) {
        const payUrl = response.result.request;
        const paymentNo = response.result.paymentNo;
        console.log(payUrl);
        state.payUrl = payUrl;
        if (payUrl) {
          // 根据不同设备采用不同支付策略
          if (isIOS.value) {
            // showToast('ios');
            displayIosPaymentDialog.value = true;
          } else {
            startNormalPayment(payUrl);
          }
        }
      }
    } catch (error) {
      handlePaymentError('支付请求失败，请重试');
    }
  };

  const confirmPay = () => {
    startIOSPayment(state.payUrl, orderModel.value.orderId);
  };

  // iOS设备支付策略
  const startIOSPayment = (payUrl, orderId) => {
    try {
      window.location.href = payUrl;
      // window.open(payUrl, '_blank');
    } catch (error) {
      console.error('iOS支付启动失败:', error);
      handlePaymentError('支付启动失败，请重试');
    }
  };

  // 普通设备支付策略
  const startNormalPayment = (payUrl) => {
    // paymentWindow.value = window.open(payUrl, '_blank');
    window.location.href = payUrl;

    // 监控支付窗口是否关闭
    // const winTimer = setInterval(() => {
    //   if (paymentWindow.value && paymentWindow.value.closed) {
    //     clearInterval(winTimer);
    //   }
    // }, 1000);
  };

  // 检查支付状态
  const checkPaymentStatus = async (orderId) => {
    // 这里应该调用实际的API
    // 示例: return await api.checkPaymentStatus({ orderId });

    // 临时模拟API调用
    return new Promise((resolve) => {
      setTimeout(() => {
        // 模拟API响应
        resolve({
          code: 200,
          result: {
            status: 'SUCCESS', // 或 'FAILED', 'PROCESSING'
          },
        });
      }, 500);
    });
  };

  // 处理支付成功
  const handlePaymentSuccess = () => {
    // 关闭支付窗口（如果存在）
    if (paymentWindow.value && !paymentWindow.value.closed) {
      paymentWindow.value.close();
    }

    // 记录支付时间
    paymentTime.value = new Date().toLocaleString();
  };

  // 处理支付超时
  const handlePaymentTimeout = () => {
    // 关闭支付窗口（如果存在）
    if (paymentWindow.value && !paymentWindow.value.closed) {
      paymentWindow.value.close();
    }

    // 清除存储的状态
    sessionStorage.removeItem('paymentInProgress');
    sessionStorage.removeItem('paymentOrderId');

    handlePaymentError('支付超时，请重新尝试');
  };

  // 处理支付错误
  const handlePaymentError = (message) => {
    // pageState.value = 'payment';
    // paymentInProgress.value = false;
    errorMessage.value = message;
  };

  // 处理页面可见性变化
  const handleVisibilityChange = () => {
    // 当页面从隐藏变为可见时（用户从支付页面返回）
    if (document.visibilityState === 'visible') {
      // 检查是否有正在进行的支付
      const paymentInProgress = sessionStorage.getItem('paymentInProgress') === 'true';

      if (paymentInProgress) {
        console.log('用户从支付页面返回，检查支付状态');
        // 立即检查一次支付状态
        checkPaymentStatus(orderModel.value.orderId).then((response) => {
          if (response.code === 200) {
            const status = response.result.status;

            if (status === 'SUCCESS') {
              handlePaymentSuccess();
            } else if (status === 'FAILED') {
              handlePaymentError('支付失败，请重试');
            }
          }
        });
      }
    }
  };

  const onClickLeft = () => {
    router.replace('/order');
  };

  const handleShowAA = () => {
    displayAADialog.value = true;
  };

  const calculateAmount = () => {
    aaAmount.value = (Number(orderModel.value.remainAmount || 0) / diners.value).toFixed(2);
  };

  const handleDinersChange = (e: any) => {
    calculateAmount();
  };

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_dialog = _resolveComponent("van-dialog")!
  const _component_van_divider = _resolveComponent("van-divider")!
  const _component_van_stepper = _resolveComponent("van-stepper")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_nav_bar, {
        title: "订单详情",
        border: "",
        fixed: "",
        "left-arrow": "",
        onClickLeft: onClickLeft
      }, {
        left: _withCtx(() => [
          _createVNode(_component_van_icon, {
            name: "arrow-left",
            size: "22",
            color: "#000"
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "w-10 h-10 rounded-full bg-green-50 flex items-center justify-center mr-3" }, [
              _createElementVNode("i", { class: "fas fa-utensils text-green-500" })
            ], -1)),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(orderModel.value.orderStatusName), 1),
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "dining-info" }, "订单已下，用餐愉快！", -1))
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["status-name", !orderModel.value.remainAmount ? 'done' : 'paying'])
          }, _toDisplayString(orderModel.value.paymentStatusName), 3)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", null, "订单号: " + _toDisplayString(orderModel.value.orderNo), 1),
          _createElementVNode("span", null, "下单: " + _toDisplayString(orderModel.value.createTime), 1)
        ]),
        (orderModel.value.tableName === '自提')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("span", null, "自提时间: " + _toDisplayString(orderModel.value.selfPickDate) + " " + _toDisplayString(orderModel.value.selfPickTime), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _cache[7] || (_cache[7] = _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80",
              alt: "餐厅图片",
              class: "restaurant-img"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(orderModel.value.shopName), 1),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", null, "桌号: " + _toDisplayString(orderModel.value.tableName), 1),
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "mx-2" }, "|", -1)),
              _createElementVNode("span", null, "用餐人数: " + _toDisplayString(orderModel.value.personCount) + "人", 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "order-title-container" }, [
          _createElementVNode("h2", { class: "order-title" }, "订单内容")
        ], -1)),
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderModel.value.foodList?.filter((i) => i.addType === 1), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "order-item"
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(item.foodName), 1),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(item.foodSpecName) + " " + _toDisplayString(item.foodCookDesc ? `| ${item.foodCookDesc}` : ''), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, "¥" + _toDisplayString(item.price), 1),
                  _createElementVNode("span", _hoisted_21, "x" + _toDisplayString(item.quantity), 1)
                ])
              ])
            ]))
          }), 128))
        ]),
        ((orderModel.value.foodList?.filter((i) => i.addType === 2) || []).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_van_icon, {
                  name: "plus",
                  color: "#ee0a24"
                }),
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "order-add-food-title" }, "加菜", -1))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderModel.value.foodList?.filter((i) => i.addType === 2), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "order-item"
                }, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("span", _hoisted_26, _toDisplayString(item.foodName), 1),
                      _createElementVNode("span", _hoisted_27, _toDisplayString(item.foodSpecName) + " " + _toDisplayString(item.foodCookDesc ? `| ${item.foodCookDesc}` : ''), 1)
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("span", _hoisted_29, "¥" + _toDisplayString(item.price), 1),
                      _createElementVNode("span", _hoisted_30, "x" + _toDisplayString(item.quantity), 1)
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (orderModel.value.seatNumber || orderModel.value.bookTime)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            (orderModel.value.seatNumber)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-gray-600" }, "座位号", -1)),
                  _createElementVNode("span", null, _toDisplayString(orderModel.value.seatNumber), 1)
                ]))
              : _createCommentVNode("", true),
            (false && orderModel.value.bookTime)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-gray-600" }, "预定时间", -1)),
                  _createElementVNode("span", null, _toDisplayString(orderModel.value.bookTime), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-gray-600" }, "商品小计", -1)),
          _createElementVNode("span", null, "¥" + _toDisplayString(orderModel.value.foodAmount), 1)
        ]),
        _createElementVNode("div", _hoisted_36, [
          _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-gray-600" }, "打包费", -1)),
          _createElementVNode("span", null, "¥" + _toDisplayString(orderModel.value.packageAmount), 1)
        ]),
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _cache[14] || (_cache[14] = _createElementVNode("span", null, "优惠券", -1)),
              _createElementVNode("span", null, "-¥" + _toDisplayString(orderModel.value.discountAmount), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_38, [
          _cache[15] || (_cache[15] = _createElementVNode("span", null, "总金额", -1)),
          _createElementVNode("span", _hoisted_39, "¥" + _toDisplayString(orderModel.value.totalAmount), 1)
        ]),
        _createElementVNode("div", _hoisted_40, [
          _cache[16] || (_cache[16] = _createElementVNode("span", null, "已支付", -1)),
          _createElementVNode("span", null, "¥" + _toDisplayString(orderModel.value.paymentAmount), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "remark" }, "备注", -1)),
        _createElementVNode("div", _hoisted_42, _toDisplayString(orderModel.value.remark), 1)
      ]),
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_43, _cache[18] || (_cache[18] = [
            _createStaticVNode("<div class=\"flex items-center justify-between\" data-v-5ba696fa><div class=\"flex items-center\" data-v-5ba696fa><div class=\"order-invoice-img\" data-v-5ba696fa><i class=\"fas fa-receipt text-blue-500\" data-v-5ba696fa></i></div><div class=\"invoice-info\" data-v-5ba696fa><div class=\"invoice-title\" data-v-5ba696fa>开具发票</div><div class=\"invoice-desc\" data-v-5ba696fa>可为本次消费申请电子发票</div></div></div><i class=\"fas fa-chevron-right\" style=\"color:#9ca3af;\" data-v-5ba696fa></i></div>", 1)
          ])))
        : _createCommentVNode("", true),
      (!!orderModel.value.remainAmount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-gray-600" }, "需支付:", -1)),
                  _createElementVNode("span", _hoisted_48, "¥" + _toDisplayString(orderModel.value.remainAmount), 1)
                ]),
                _createElementVNode("div", { onClick: handleShowAA }, [
                  _createVNode(_component_van_image, {
                    width: "30",
                    height: "30",
                    src: "/images/AA.png"
                  })
                ])
              ]),
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "payment-remark" }, "用餐结束后请完成支付", -1))
            ]),
            (paymentLine.value === 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "ios-button",
                  onClick: handleStartPayment
                }, " 立即支付 "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_van_dialog, {
      show: displayIosPaymentDialog.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((displayIosPaymentDialog).value = $event)),
      title: " ",
      "show-cancel-button": "",
      onConfirm: confirmPay
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_49, [
          _createVNode(_component_van_image, {
            width: "100",
            fit: "contain",
            src: "https://gw.alipayobjects.com/mdn/rms_7e962d/afts/img/A*yCL8TrkjIx8AAAAAAAAAAAAAARQnAQ",
            class: "restaurant-image",
            style: {"text-align":"center"}
          }),
          _cache[21] || (_cache[21] = _createElementVNode("div", { style: {"text-align":"center","line-height":"24px","color":"blue","padding":"15px"} }, "是否跳转至支付宝页面", -1))
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_dialog, {
      show: displayAADialog.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((displayAADialog).value = $event)),
      "show-confirm-button": false,
      class: "order-success-dialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_50, [
          _createVNode(_component_van_icon, {
            name: "close",
            class: "close-icon",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (displayAADialog.value = false))
          }),
          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "success-title" }, "计算AA金额", -1)),
          _createVNode(_component_van_divider, { style: { borderColor: '#979da1', padding: '0 16px', width: '100%' } }),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _cache[22] || (_cache[22] = _createElementVNode("span", null, "支付金额", -1)),
              _createElementVNode("span", null, _toDisplayString(orderModel.value.remainAmount), 1)
            ]),
            _createElementVNode("div", _hoisted_53, [
              _cache[23] || (_cache[23] = _createElementVNode("span", null, "用餐人数", -1)),
              _createElementVNode("span", null, [
                _createVNode(_component_van_stepper, {
                  modelValue: diners.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((diners).value = $event)),
                  onChange: handleDinersChange
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _cache[24] || (_cache[24] = _createElementVNode("span", null, "人均", -1)),
              _createElementVNode("span", null, " ￥" + _toDisplayString(aaAmount.value), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_55, [
            _createVNode(_component_van_button, {
              round: "",
              block: "",
              color: _unref(h5Config).themeColor,
              class: "dialog-button",
              onClick: calculateAmount
            }, {
              default: _withCtx(() => _cache[25] || (_cache[25] = [
                _createTextVNode(" 计算 ")
              ])),
              _: 1,
              __: [25]
            }, 8, ["color"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})